import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Profile from './Profile/Profile';
import './styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faIdBadge } from '@fortawesome/free-regular-svg-icons';
import {
  faTachometerAlt,
  faAngleRight,
} from '@fortawesome/free-solid-svg-icons';
import SubscriptionContainer from './Subscription/SubscriptionContainer';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import { withTranslation } from 'react-i18next';
import { PulseLoader } from 'react-spinners';

class Account extends Component {
  state = {
    isSelected: 'profile',
    showComponent: false,
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.getSubscription();
    this.setState(
      {
        isSelected: 'profile',
      },
      () => {
        this.navigateTo(this.state.isSelected);
      }
    );
  }

  displayComponent = (show, value) => {
    this.setState({
      showComponent: show,
      isSelected: value,
    });
  };

  navigateTo = (value) => {
    window.digitalData.link = {
      linkName: value,
      linkType: 'Tab',
    };
    AnalyticsService.trackEvent('link_click');

    this.setState({
      isSelected: value,
    });
  };

  renderComponent = () => {
    let { isSelected, showComponent } = this.state;
    const { t } = this.props;
    if (showComponent) 
      return (
        <div className="tablet-component-wrapper">
          {isSelected === 'profile' && (
            <Profile displayComponent={this.displayComponent} />
          )}
          {isSelected === 'subscription' && (
            <SubscriptionContainer displayComponent={this.displayComponent} />
          )}
        </div>
      ) 
    else 
      return (
        <div className="account-tablet-wrapper">
          <div className="account-title">{t('account')}</div>
          <div className="personal-info-title">{t('personalInfo')}</div>
          <div className="account-options">
            <div
              className="account-tab"
              onClick={this.displayComponent.bind(this, true, 'profile')}
            >
              <div className="account-tab-details">
                <FontAwesomeIcon className="account-icon" icon={faIdBadge} />
                <p className="tab-name">{t('profile')}</p>
              </div>
              <FontAwesomeIcon className="account-icon" icon={faAngleRight} />
            </div>
            <div
              className="account-tab"
              onClick={this.displayComponent.bind(this, true, 'subscription')}
            >
              <div className="account-tab-details">
                <FontAwesomeIcon
                  className="account-icon"
                  icon={faTachometerAlt}
                />
                <p className="tab-name">{t('subscription')}</p>
              </div>
              <FontAwesomeIcon className="account-icon" icon={faAngleRight} />
            </div>
          </div>
        </div>
      )
  }

  render() {
    let { isSelected } = this.state;
    let { notificationCount } = this.props.subscription;
    const { t } = this.props;
    let profile;
    if (isSelected === 'profile') profile = 'nav-item-selected';
    else profile = '';

    let subscription;
    if (isSelected === 'subscription') subscription = 'nav-item-selected';
    else subscription = '';

    let notificationInfo;
    if (notificationCount > 0) 
    notificationInfo = (
      <span className="notification-info"></span>
    ) ;
    else notificationInfo = null;

    return (
      <div className="account-view-wrapper">
        {this.props.generic.initialLoad ? <div className='init-loader'><PulseLoader color={'#ffffff'} style={{ marginBottom: 24, marginTop: 24 }} /></div> : <>
        <div className="account-desktop-wrapper">
          <div className="account-details-wrapper">
            <div className="account-title">{t('account')}</div>
            <div className="account-header">
              <div
                className={`nav-item ${profile}`}
                onClick={this.navigateTo.bind(this, 'profile')}
              >
                {t('profile')}
              </div>
              <div
                className={`nav-item ${subscription}`}
                onClick={this.navigateTo.bind(this, 'subscription')}
              >
                <span>{t('subscription')}</span>{' '}
                {notificationInfo}
              </div>
            </div>
          </div>
        </div>

        <div className="component-wrapper">
          {isSelected === 'profile' && <Profile />}
          {isSelected === 'subscription' && <SubscriptionContainer />}
        </div>
        {this.renderComponent()}
        </>}
      </div>
    );
  }
}

export default withTranslation()((withRouter(Account)));
